'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
import React from 'react';
import { findClosestGlyphAvailable, Icon, IconSizeMap } from "../../index.mjs";

/**
 * Our icon component is built on top of Encore's icon set.
 * Read our [iconography documentation](https://encore.spotify.net/foundations/iconography?format=figma-figma) to learn more about the principles our icons were designed upon.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-icon--docs) |
 * [Encore site](https://encore.spotify.net/web/components/icon) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Icon/icons/IconDeviceCarExit/index.tsx)
 */
export function IconDeviceCarExit(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M11.692 1.186A2.748 2.748 0 0 0 10.697 1H5.302a2.75 2.75 0 0 0-2.381 1.375L1.983 4H.75a.75.75 0 0 0 0 1.5h.237C-.002 6.4-.001 7.617 0 8.207v4.672l1.5-1.5V9.5h1.879L4.61 8.267A.996.996 0 0 0 3.931 8H1.502c.014-.56.097-1.077.57-1.454a2.72 2.72 0 0 0 .055-.046H6.38L7.88 5H3.137L4.22 3.125A1.25 1.25 0 0 1 5.302 2.5h5.077l1.313-1.314zM14.47.53a.748.748 0 0 1 1.06 0 .75.75 0 0 1 0 1.061L1.591 15.531a.75.75 0 1 1-1.06-1.061L14.47.53zM5.243 14H13v1.25c0 .414.336.75.75.75h1.5a.75.75 0 0 0 .75-.75V8.207c0-.59.002-1.807-.987-2.707h.237a.75.75 0 0 0 0-1.5h-.008l-2.5 2.5h1.13l.056.046c.473.377.556.894.57 1.454h-2.429a1 1 0 0 0-1 1v.5h3.43v3H6.744l-1.5 1.5z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M18.267 1.904A4.998 4.998 0 0 0 15.4 1H8.601a5 5 0 0 0-4.33 2.5L3.405 5H1a1 1 0 0 0 0 2h1.05A3.925 3.925 0 0 0 0 10.45v9.722l2-2v-.341l.276.065 1.683-1.684A40.703 40.703 0 0 1 2 15.772v-3.238c.221.095.448.179.675.254 1.07.354 2.297.556 3.226.649a1 1 0 0 0 .198-1.99c-.842-.085-1.912-.266-2.797-.558-.443-.147-.8-.308-1.048-.471a1.319 1.319 0 0 1-.24-.195A1.93 1.93 0 0 1 3.33 8.617l.018-.006c2.38.499 4.833.795 7.34.872l1.986-1.985a40.23 40.23 0 0 1-8.017-.667L6.003 4.5A3 3 0 0 1 8.6 3h6.798c.503 0 .988.126 1.417.356l1.451-1.452zM22.293.707a.996.996 0 0 1 1.414 0 1 1 0 0 1 0 1.414L2.121 23.707a1 1 0 0 1-1.414-1.414L22.293.707zM9.716 18.94A43.67 43.67 0 0 0 18 18.585V20.5a1.5 1.5 0 0 0 1.5 1.5h3a1.5 1.5 0 0 0 1.5-1.5V10.45c0-1.49-.83-2.785-2.05-3.45H23a1 1 0 0 0 .515-1.858l-3.62 3.62c.253-.048.505-.098.757-.15l.018.005a1.93 1.93 0 0 1 1.317 1.605c-.045.049-.12.115-.241.196-.249.163-.604.324-1.048.47-.885.293-1.955.474-2.797.558a1 1 0 1 0 .198 1.99c.93-.092 2.155-.294 3.226-.648.227-.075.454-.16.675-.254v3.238a41.282 41.282 0 0 1-10.342 1.226L9.716 18.94zM20 18.257a43.78 43.78 0 0 0 2-.426V20h-2v-1.743z\'/>'
  }];
  var iconSizeValue = props.size ? IconSizeMap[props.size] : props.iconSize;
  var closestSize = findClosestGlyphAvailable(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconDeviceCarExit is deprecated and will be archived soon. Use IconDeviceCarExit instead.
 */
export function Experimental__IconDeviceCarExit(props) {
  return /*#__PURE__*/React.createElement(IconDeviceCarExit, props);
}